import { Divider, Form, Grid, Input, Text } from '@wework/dieter-ui'
import React from 'react'
import IMTheme from '../../style/IMTheme'
import { Radio } from 'semantic-ui-react'

export default function EditPricing() {
  return (
    <>
      <Grid style={{ marginTop: IMTheme.spacing[5] }}>
        <Grid.Row stretched>
          <Grid.Column>
            <div>
              <Text style={{ fontWeight: 'bold', fontSize: 16 }}>Pricing</Text>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8} style={{ width: '50%' }}>
            <div>
              <Text
                style={{ fontWeight: 'bold', fontSize: IMTheme.fontSizes[3] }}
              >
                Is this room free to book?
              </Text>
              <Text size="small" style={{ color: '#777' }}>
                Booking doesn’t require any credits.{' '}
              </Text>
            </div>
          </Grid.Column>
          <Grid.Column
            width={8}
            style={{
              width: '50%',
              display: 'flex',
              alignItems: 'flex-end',
            }}
          >
            <Radio label="No" toggle />
          </Grid.Column>
        </Grid.Row>
        <Divider light style={{ width: '100%' }} />
        <Grid.Row stretched>
          <Grid.Column width={8}>
            <Text>Pricing Rules</Text>
            <Text size="small" style={{ color: '#777' }}>
              Set how the rooms are priced. Credits are shown per 30 minutes
              time slot. <br />
              <br />
              To make any changes to this, please use{' '}
              <a href="https://rooms.wework.com/">Rooms Admin</a>.
            </Text>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid>
              <Grid.Row
                stretched
                style={{
                  border: '1px solid #eee',
                  borderRadius: '5px',
                  marginRight: '12px',
                  height: 'fit-content',
                }}
              >
                <Grid.Column width={8}>
                  <text fontSize="14px">
                    Peak
                    <br />
                    <text style={{ color: '#777' }}>1100 - 1600</text>
                  </text>
                </Grid.Column>
                <Grid.Column
                  width={8}
                  style={{
                    width: '50%',
                    display: 'flex',
                    alignItems: 'flex-end',
                    alignSelf: 'center',
                  }}
                >
                  <text fontSize="14px">1.5 Credit</text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row
                stretched
                style={{
                  border: '1px solid #eee',
                  borderRadius: '5px',
                  marginRight: '11px',
                  height: 'fit-content',
                }}
              >
                <Grid.Column width={8}>
                  <text fontSize="14px">
                    Default
                    <br />
                    <text style={{ color: '#777' }}>1100 - 1600</text>
                  </text>
                </Grid.Column>
                <Grid.Column
                  width={8}
                  style={{
                    width: '50%',
                    display: 'flex',
                    alignItems: 'flex-end',
                    alignSelf: 'center',
                  }}
                >
                  <text fontSize="14px">1.0 Credit</text>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}
